import { render, staticRenderFns } from "./MyCandidates.vue?vue&type=template&id=06f2e669&scoped=true&"
import script from "./MyCandidates.vue?vue&type=script&lang=js&"
export * from "./MyCandidates.vue?vue&type=script&lang=js&"
import style0 from "./MyCandidates.vue?vue&type=style&index=0&id=06f2e669&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2e669",
  null
  
)

export default component.exports